<script>
  export let value;
  export let append = undefined;
  export let appendShort = undefined;
  export let small = false;
</script>

<div class='small-title' class:small-title-small={small}>
  <div class='small-title-value'>
    <div class='small-title-value-content'> {value} </div>

    {#if !small} <div class='small-title-value-gradient'/> {/if}
  </div>

  {#if append} <div class='small-title-append'> {append} </div> {/if}
  {#if appendShort} <div class='small-title-append-short'> {appendShort} </div> {/if}
</div>

<style>
  .small-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .small-title-value {
    position: relative;

    width: 100%;
    height: 40px;
  }

  .small-title-value-content {
    display: flex;
    align-items: center;

    height: 100%;

    padding-right: 40px;

    font-family: var(--font-secondary);
    font-size: 32px;

    overflow-x: scroll;

    white-space: nowrap;

    scrollbar-width: none;
  }

  .small-title-value-content::-webkit-scrollbar {
    display: none;
  }

  .small-title-value-gradient {
    position: absolute;
    top: 0px;
    right: 0px;

    width: 60px;
    height: 100%;

    background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 87.5%);
  }

  .small-title-append {
    display: flex;
    align-items: center;

    height: 40px;

    font-family: var(--font-secondary-light);
    font-size: 32px;

    color: var(--grey-6);

    white-space: nowrap;
  }

  .small-title-append-short {
    display: none;
    align-items: center;

    height: 40px;

    font-family: var(--font-secondary-light);
    font-size: 32px;

    color: var(--grey-6);

    white-space: nowrap;
  }

  .small-title-small .small-title-value {
    height: 20px;
  }

  .small-title-small .small-title-value-content {
    font-size: 16px;
  }

  .small-title-small .small-title-append {
    height: 20px;

    font-size: 16px;
  }

  :global(body.dark) .small-title-value-gradient {
    background: linear-gradient(90deg, rgba(33, 33, 33, 0), rgba(33, 33, 33, 1) 87.5%);
  }

  @media only screen and (max-width: 600px) {
    .small-title-append {
      display: none;
    }

    .small-title-append-short {
      display: flex;
    }
  }
</style>
